// pdp-modal

if (!customElements.get('pdp-modal')) {
  class PdpModal extends HTMLElement {
    constructor() {
      super()
      this.overlay = this.querySelector('.js-pdp-modal-overlay')
      this.backdrop = this.querySelector('.js-pdp-modal-backdrop')
      this.closeBtn = this.querySelector('.js-pdp-modal-close')
      this.closeBtns = this.querySelectorAll('.js-pdp-modal-close')
      this.trigger = this.querySelector('.js-pdp-modal-trigger')
      // Store bound handlers for proper cleanup
      this.handleOpen = this.open.bind(this)
      this.handleClose = this.close.bind(this)
      this.handleKeyDown = this.onKeyDown.bind(this)
    }

    connectedCallback() {
      this.trigger?.addEventListener('click', this.handleOpen)
      this.backdrop?.addEventListener('click', this.handleClose)
      this.closeBtns.forEach((btn) => btn.addEventListener('click', this.handleClose))
      document.addEventListener('keydown', this.handleKeyDown)
      // Mark as no-animation for reduced motion users
      if (this.prefersReducedMotion()) {
        this.overlay?.classList.add('no-animation')
      }
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.handleOpen)
      this.backdrop?.removeEventListener('click', this.handleClose)
      this.closeBtns.forEach((btn) => btn.removeEventListener('click', this.handleClose))
      document.removeEventListener('keydown', this.handleKeyDown)
    }

    open() {
      this.overlay.classList.add('is-open')
      // Remember what was there (the quick add modal locks scroll with !important) to restore it
      this.previousOverflow = {
        value: document.body.style.getPropertyValue('overflow'),
        priority: document.body.style.getPropertyPriority('overflow'),
      }
      document.body.style.overflow = 'hidden'
      // Start bar animations after modal open animation completes
      if (!this.prefersReducedMotion()) {
        this.animationTimeout = setTimeout(() => {
          this.overlay.classList.add('is-animating')
        }, 300)
      }
    }

    close() {
      this.overlay.classList.remove('is-open')
      this.overlay.classList.remove('is-animating')
      const { value, priority } = this.previousOverflow || { value: '', priority: '' }
      if (value) document.body.style.setProperty('overflow', value, priority)
      else document.body.style.removeProperty('overflow')
      if (this.animationTimeout) clearTimeout(this.animationTimeout)
      const content = this.overlay.querySelector('.pdp-modal__content')
      if (content) content.scrollTop = 0
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches
    }

    onKeyDown(event) {
      if (event.key === 'Escape' && this.overlay.classList.contains('is-open')) {
        this.close()
      }
    }
  }

  customElements.define('pdp-modal', PdpModal)
}
